module.exports = __webpack_public_path__ + "static/andreas-fa2be9fe178dbb1e27be49c7916b4581.png";